import React from 'react'
import UseHTML from '../../../components/hook/UseHTML';

const DigitalBadge = props => {
    const { content, header } = props;
    return ( 
        <div className='digital_badge'>
            <figure><img src='/images/badge-base.png' alt={header} /></figure>
            <div>
                <h2>{header}</h2>
                <UseHTML html={content} />
                <div className='badge_buttons'>
                    <a href="https://bit.ly/gafeteIG" target="_blank" rel="noreferrer" className='button blue'>Instagram</a>
                    <a href="https://bit.ly/gafeteFB" target="_blank" rel="noreferrer" className='button blue'>Facebook</a>
                    <a href="https://bit.ly/GafeteL39" target="_blank" rel="noreferrer" className='button blue'>Booth</a>
                </div>
            </div>
        </div>


    )
}

export default DigitalBadge
